import { bankDetailsInitState, BankDetailsType } from '../../hooks/useBank';

export type RedemptionAPIRequestType = {
    reqId: string;
    // pan: string;
    // email: string;
    // pekrn: string;
    data: [RedemptionAPIDataKeyType];
};

export type RedemptionAPIDataKeyType = {
    amc: string;
    schemeOptions: [RedemptionSchemeOptionsType];
    source: 'web' | 'mobile';
};

export type RedemptionSchemeOptionsType = {
    itemNo: string;
    folio: string;
    isin: string;
    amount: string;
    units: string;
    allUnits: string;
    trxnDate: string;
    trxnTime: string;
    userTrxNo: string;
    bank: BankDetailsType;
};

type RedemptionActionType = {
    type: string;
    body: RedemptionSchemeOptionsType;
};

export enum REDEMPTION_ACTION_TYPES {
    ADD = 'ADD_REDEMPTION',
    REMOVE = 'REMOVE_REDEMPTION',
}

const schemeOptionsInitialState = [
    {
        itemNo: '',
        folio: '',
        isin: '',
        amount: '',
        units: '',
        allUnits: '',
        trxnDate: '',
        trxnTime: '',
        userTrxNo: '',
        bank: bankDetailsInitState,
    },
];

const redemptionReducer = (
    state: Array<RedemptionSchemeOptionsType> = schemeOptionsInitialState,
    action: RedemptionActionType,
): Array<RedemptionSchemeOptionsType> => {
    switch (action.type) {
        case 'ADD_REDEMPTION':
            if (state[0] === schemeOptionsInitialState[0]) {
                return [action.body];
            }
            return [...state, action.body];
        case 'REMOVE_REDEMPTION':
            return state.filter((item) => item.folio !== action.body.folio);
        default:
            return state;
    }
};
export default redemptionReducer;
